import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import WorkflowDefinitionModel from '../../models/WorkflowDefinitionModel';
import DataService from "../../services/data.service";
import Workflows_popup_CreateWorkflow from "./Popups/Workflows_popup_CreateWorkflow";

const WorkflowDefinitions: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const [showCreatePopup, setShowCreatePopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForWorkflowDefinition } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/workflowDefinitions')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function add() {
        setShowCreatePopup(true);
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/workflowDefinitions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    function canDeleteRow(rowData: WorkflowDefinitionModel)
    {
        return isAuthorizedForWorkflowDefinition(ApplicationFunctions.DeleteWorkflowDefinition, rowData.id)
    }

    return (
        <div className='main-content'>
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <Card title='Workflows'
                            content={
                                <DataTable
                                    name='dtWorkflowDefinitions'
                                    tableData={data}
                                    navigateTitle='Workflow setup'
                                    navigateUrl='/plm/workflowsetup/workflow/'
                                    colInfos={[
                                        { key: true, dataProp: 'id', visible: false },
                                        { title: 'Name', dataProp: 'name', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
                                        { title: 'Description', dataProp: 'desciption', filterInfo: { filterType: 'Textbox' } },
                                        { title: 'Sub-Item workflow', dataProp: 'isSubItemWorkflow', dataType:'bool' },
                                        {
                                            headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: add, applicationFunctions: [ApplicationFunctions.CreateWorkflowDefinition] }],
                                            rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow, isVisible: canDeleteRow }],
                                        }
                                    ]}

                                />
                            }
                        />
                    </Col>
                </Row>
                {showCreatePopup && <Workflows_popup_CreateWorkflow show={showCreatePopup} onHide={() => { setShowCreatePopup(false); getTableData(); }} />}
            </Container>
        </div>
    );
}
export default WorkflowDefinitions;